export function SubscriptionViewModel(data) {
  this.Id = data.subscriptionId;
  this.Name = data.displayName;
}
